import { createBrowserRouter } from "react-router-dom";

import AnalyticsPage from "src/pages/analytics";
import LoginPage from "src/pages/login";
import HomePage from "src/pages/home";
import SettingsPage from "src/pages/settings";
import TeamDetailPage from "src/pages/home/team-details";
import WorkerDetailsPage from "src/pages/home/team-details/worker-details";
import WorkerAssignPage from "src/pages/home/team-details/worker-assign";
import GreenhouseGridPage from "src/pages/home/team-details/greenhouse-grid";
// import TasksPage from "src/pages/tasks";
import ToDoPage from "src/pages/todo";
import { ProtectedRoute } from "src/components";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <ProtectedRoute />,
    children: [
      {
        index: true, 
        element: <HomePage />,
      },
      {
        path: "team/:teamId",
        element: <TeamDetailPage />,
      },
      {
        path: "team/:teamId/worker/:workerId",
        element: <WorkerDetailsPage />,
      },
      {
        path: "team/:teamId/worker/:workerId/assign",
        element: <WorkerAssignPage />,
      },
      {
        path: "team/:teamId/greenhouse",
        element: <GreenhouseGridPage />,
      },
      {
        path: "analytics/*",
        element: <AnalyticsPage />,
      },
      {
        path: "todo",
        element: <ToDoPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
    ],
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
]);